/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyInfoResult
 */
export interface CRSFSecReviewPrivacyInfoResult {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    app_store_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    consent_banners?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    do_not_sell_link: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    has_gpc: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    initial_cookies?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    meta: { [key: string]: { [key: string]: any; }; };
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    privacy_policy_link: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    social_media_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CRSFSecReviewPrivacyInfoResult
     */
    trackers: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyInfoResult interface.
 */
export function instanceOfCRSFSecReviewPrivacyInfoResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "do_not_sell_link" in value;
    isInstance = isInstance && "has_gpc" in value;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "privacy_policy_link" in value;
    isInstance = isInstance && "trackers" in value;

    return isInstance;
}

export function CRSFSecReviewPrivacyInfoResultFromJSON(json: any): CRSFSecReviewPrivacyInfoResult {
    return CRSFSecReviewPrivacyInfoResultFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyInfoResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyInfoResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'app_store_links': !exists(json, 'app_store_links') ? undefined : json['app_store_links'],
        'consent_banners': !exists(json, 'consent_banners') ? undefined : json['consent_banners'],
        'do_not_sell_link': json['do_not_sell_link'],
        'has_gpc': json['has_gpc'],
        'initial_cookies': !exists(json, 'initial_cookies') ? undefined : json['initial_cookies'],
        'meta': json['meta'],
        'privacy_policy_link': json['privacy_policy_link'],
        'social_media_links': !exists(json, 'social_media_links') ? undefined : json['social_media_links'],
        'trackers': json['trackers'],
    };
}

export function CRSFSecReviewPrivacyInfoResultToJSON(value?: CRSFSecReviewPrivacyInfoResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_store_links': value.app_store_links,
        'consent_banners': value.consent_banners,
        'do_not_sell_link': value.do_not_sell_link,
        'has_gpc': value.has_gpc,
        'initial_cookies': value.initial_cookies,
        'meta': value.meta,
        'privacy_policy_link': value.privacy_policy_link,
        'social_media_links': value.social_media_links,
        'trackers': value.trackers,
    };
}

